import axios from "axios";

axios.interceptors.response.use(
  (response) => {
    return response; // If response is valid, return the response
  },
  (error) => {
    // Check if the error response status is 401 Unauthorized (invalid/missing token)
    if (error.response && error.response.status === 401) {
      const errorMessage = error.response.data?.message || "Unauthorized";
      console.error(`JWT Token Error: ${errorMessage}`);

      // If the token is expired or invalid, you can clear the local storage or session
      localStorage.removeItem("token");

      // Redirect to login page (use history.push('/login') for React Router)
      window.location.href = "/login"; // Or use history.push('/login') if you use React Router's `useHistory`
    }

    return Promise.reject(error);
  }
);
